export var formatNumber = function (value) {
    if (!isNumber(value)) {
        return;
    }
    var intValue = parseInt(String(value));
    var abs = Math.abs(intValue);
    if (abs && abs > 999) {
        var formattedValue = Math.sign(intValue) * parseFloat((abs / 1000).toFixed(1)) + "K";
        return formattedValue.replace('.', ',');
    }
    return intValue;
};
export var isNumber = function (value) { return typeof value === 'number'; };
